import { recordErrorInSentry } from "../../utils/init-sentry.js";
import { disposeMeetingClient } from "./table-call-client-disposal.js";
import type { MeetingClient } from "./table-call.context.js";
import type { SerializedQueueRef } from "./table-call.types.js";

export const delay = (ms: number) => {
  const { promise, resolve } = Promise.withResolvers<null>();
  setTimeout(() => resolve(null), ms);
  return promise;
};

export const enqueueSerialized = <T>(
  queueRef: SerializedQueueRef,
  operation: () => Promise<T>
): Promise<T> => {
  const { promise, reject, resolve } = Promise.withResolvers<T>();
  const previousOperation = queueRef.current;
  queueRef.current = (async () => {
    try {
      await previousOperation;
    } catch {
      // A failed operation must not block later state-machine transitions.
    }
    try {
      resolve(await operation());
    } catch (error) {
      reject(error);
    }
  })();
  return promise;
};

export const leaveClient = async (
  client: MeetingClient,
  shouldReportError: boolean
): Promise<boolean> => {
  console.info("[TableCall] client.leave started");
  const result = await disposeMeetingClient(client);
  if (result.status === "completed") {
    console.info("[TableCall] client.leave completed");
    return true;
  }
  console.error("[TableCall] client.leave failed", result.error);
  if (shouldReportError) {
    recordErrorInSentry(result.error, {
      extra: {
        fallbackCleanupFailures: result.fallbackErrors.length,
        leaveOutcome: result.status,
      },
    });
  }
  return false;
};
